module.exports = __webpack_public_path__ + "static/transparency-hotspot-7ca10c26a6cb199b54437db65f19ea8b.webm";